document.addEventListener("DOMContentLoaded", () => {
  // Stores discounted cents from the selected quantity-break option.
  // Set on checkbox click so it survives any UI reset Measura does during submit.
  let _mfBulkDiscountCents = null;

  /** Discounted Functionality - Quantity Breaks **/
  const quantityBreakMain = document.querySelector(".quantity-breaks");
  const quantityBreaksList = quantityBreakMain?.querySelectorAll(".option-block");

  // Returns the highest discount tier whose minimum qty ≤ currentQty,
  // updates all pill checked states + selected class, and sets _mfBulkDiscountCents.
  function applyQuantityBreakTier(qty) {
    if (!quantityBreaksList?.length) return;
    const currentQty = parseInt(qty) || 0;

    const tiers = Array.from(quantityBreaksList).map(block => {
      const input = block.querySelector('input[type="checkbox"]');
      const tierQty = parseInt(input?.value) || 0;
      const dStr = block.querySelector('[data-price]')?.getAttribute('data-price') || '';
      const cents = dStr ? parseInt(dStr.replace('.', ''), 10) : null;
      return { block, input, tierQty, cents };
    }).filter(t => t.tierQty > 0 && t.cents);

    tiers.sort((a, b) => b.tierQty - a.tierQty); // highest threshold first

    const best = tiers.find(t => currentQty >= t.tierQty) || null;

    tiers.forEach(t => {
      if (t.input) t.input.checked = (t === best);
      t.block.classList.toggle('selected', t === best);
    });

    _mfBulkDiscountCents = best ? best.cents : null;
  }

  quantityBreaksList?.forEach((breakItem) => {
    console.log("CHeck on load qty");
    const qtyInput = breakItem.querySelector('input[type="checkbox"]');
    const mainProductInfo = breakItem.closest("product-info") || document.querySelector("product-info");
    const quantityInput = mainProductInfo?.querySelector('.mf-quantity-input input[name="quantity"]');

    const minCartQtyAttr = quantityInput?.getAttribute("data-min-cart-quantity");
    const minCartQty = minCartQtyAttr ? parseInt(minCartQtyAttr) : null;
    const updateMinusState = () => {
      const minusBtn = mainProductInfo?.querySelector('.quantity__button[name="minus"]');
      if (!minusBtn || minCartQty === null) return;

      const currentQty = parseInt(quantityInput.value) || 1;

      if (currentQty <= minCartQty) {
        minusBtn.classList.add("disabled");
        minusBtn.disabled = true;
      } else {
        minusBtn.classList.remove("disabled");
        minusBtn.disabled = false;
      }
    };
    if (minCartQty !== null) {
      const currentVal = parseInt(quantityInput.value) || 1;
      if (currentVal < minCartQty) {
        quantityInput.value = minCartQty;
      }

      // updateMinusState();
    }
    // PREVENT USER FROM REDUCING BELOW MIN CART QUANTITY
    if (minCartQty !== null && quantityInput) {
      // Prevent manual typing below min
      quantityInput.addEventListener("input", () => {
        if (parseInt(quantityInput.value) < minCartQty) {
          quantityInput.value = minCartQty;
        }
        // updateMinusState();
      });

      quantityInput.addEventListener("change", () => {
        if (parseInt(quantityInput.value) < minCartQty) {
          quantityInput.value = minCartQty;
        }
        // updateMinusState();
      });

      // Prevent "-" button going below min
      const minusBtn = mainProductInfo?.querySelector('.quantity__button[name="minus"]');
      if (minusBtn) {
        minusBtn.addEventListener("click", () => {
          setTimeout(() => {
            if (parseInt(quantityInput.value) < minCartQty) {
              quantityInput.value = minCartQty;
            }
            // updateMinusState();
          }, 10);
        });
      }

      // Plus button also needs to update minus state
      const plusBtn = mainProductInfo?.querySelector('.quantity__button[name="plus"]');
      if (plusBtn) {
        plusBtn.addEventListener("click", () => {
          setTimeout(() => {
            // updateMinusState();
          }, 10);
        });
      }
    }

    qtyInput?.addEventListener("change", (event) => {

      const isChecked = event.target.checked;

      // Selected value
      let qtyVal = isChecked ? (parseInt(event.target.value) || 1) : 1;

      // Apply min-cart-quantity if exists
      if (minCartQty !== null && qtyVal < minCartQty) {
        qtyVal = minCartQty;
      }

      // Set quantity input
      if (quantityInput) {
        event.target.closest(".product__info-wrapper").querySelector('input[name="quantity"]').value = parseInt(qtyVal);
      }

      // Sync all pill states and _mfBulkDiscountCents for this qty
      applyQuantityBreakTier(qtyVal);

      // Also update Measura legacy block input for decimal products
      const measuraInput = mainProductInfo?.querySelector('.measura-legacy-block input');
      if (measuraInput) {
        measuraInput.value = qtyVal;
        measuraInput.dispatchEvent(new Event('input', { bubbles: true }));
        measuraInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateMinusState();
      // Set Yard To Meter Convertor 
      const yardValue = isChecked ? parseInt(event.target.value) || 1 : 1;
      const yard_to_meter = 0.9144;
      let meters = (yardValue * yard_to_meter).toFixed(2);
      const meterBox = mainProductInfo?.querySelector('.meter-convertor');
      if (meterBox) {
        meterBox.innerText = `(${meters} Meter${yardValue > 1 ? "s" : ""})`;
      }

      let rewardMultiplier = isChecked ? parseInt(event.target.value) || 1 : 1;;
      document.querySelectorAll(".block_product-reward-point").forEach(pointEl => {
        let rawPoints = pointEl.getAttribute("data-point");



        if (rawPoints) {
          let numericPoints = parseFloat(rawPoints);
          if (!isNaN(numericPoints)) {
            let finalPoints = ((numericPoints * rewardMultiplier));
            pointEl.textContent = Shopify.formatMoney(finalPoints);
            console.log("finalPoints", finalPoints)
          }
        }
      });




    });
  });

  // Sync tier whenever the quantity is changed manually (typing or +/- buttons).
  // A single listener set, not per-breakItem, to avoid duplicates.
  if (quantityBreaksList?.length) {
    const _pInfo = quantityBreaksList[0].closest('product-info') || document.querySelector('product-info');
    const _qInput = _pInfo?.querySelector('.mf-quantity-input input[name="quantity"]');
    if (_qInput) {
      const _syncTier = () => applyQuantityBreakTier(parseInt(_qInput.value) || 0);
      _qInput.addEventListener('change', _syncTier);
      _qInput.addEventListener('input', _syncTier);
      // +/- buttons update the DOM value before firing — wait one tick to read it
      _pInfo?.querySelectorAll('.quantity__button').forEach(btn => {
        btn.addEventListener('click', () => setTimeout(_syncTier, 30));
      });
    }
  }

  /** Meter Convertor — initialize on load and on quantity input change **/
  const yard_to_meter = 0.9144;
  function updateMeterDisplay(yardsValue, meterBox) {
    if (!meterBox) return;
    const yards = parseFloat(yardsValue) || 0;
    if (yards <= 0) {
      meterBox.innerText = '';
      return;
    }
    const meters = (yards * yard_to_meter).toFixed(2);
    meterBox.innerText = `(${meters} Meter${yards !== 1 ? 's' : ''})`;
  }


  /** Measura + Bulk Discount: patch buildLineItemProperties to inject discounted unit price **/
  // Rather than intercepting form submit (which races with Measura's own handler), we wrap
  // window.Measura.buildLineItemProperties so that when Measura calls it during its normal
  // add-to-cart flow, we transparently replace the "Unit price" property with the discounted
  // per-unit price from the selected quantity-break option.
  function patchMeasuraUnitPrice() {
    if (!window.Measura || typeof window.Measura.buildLineItemProperties !== 'function') return false;
    if (window.Measura.__mfDiscountPatched) return true; // already patched

    const _orig = window.Measura.buildLineItemProperties.bind(window.Measura);

    window.Measura.buildLineItemProperties = async function(options) {
      const result = await _orig(options);

      // Use the value captured at checkbox-click time (not DOM state at submit time,
      // since Measura may have already unchecked the pills by then).
      if (!_mfBulkDiscountCents) return result;

      // Use the unit from Measura's own "Unit price" entry (e.g. "$19.96 / yd" → "yd")
      const idx = result.findIndex(p => p.name === 'Unit price');
      if (idx < 0) return result; // no Unit price property — not a priced Measura item

      const unit = result[idx].value.split(' / ')[1] || 'yd';
      result[idx] = { name: 'Unit price', value: `${Shopify.formatMoney(_mfBulkDiscountCents)} / ${unit}` };

      return result;
    };

    window.Measura.__mfDiscountPatched = true;
    return true;
  }

  // Measura may be async-loaded, so poll until it's available then patch once
  if (!patchMeasuraUnitPrice()) {
    const _patchInterval = setInterval(() => {
      if (patchMeasuraUnitPrice()) clearInterval(_patchInterval);
    }, 100);
    setTimeout(() => clearInterval(_patchInterval), 15000);
  }

  /** Recently Viewed Products **/
  const productHandle = window.location.pathname.split("/").pop();
  addRecentlyViewedProduct(productHandle);

  const recentlyViewed = getRecentlyViewedProducts().filter(
    (handle) => handle !== productHandle
  );

  const targetElementContainer = document.querySelector(".recently-viewed-grid");
  if (targetElementContainer) {
    targetElementContainer.innerHTML = "";

    // Track appended handles to avoid duplicates
    const appendedHandles = new Set();

    recentlyViewed.forEach((handle) => {
      if (!appendedHandles.has(handle)) {
        appendedHandles.add(handle);
        const url = `/products/${handle}?view=recent-view`;
        fetchAndInjectHTML(url, ".recently-viewed-grid", handle);
      }
    });
  }

  // Also check visibility on load
  updateRecentlyViewedWrapperVisibility();

});

/** Fetch product snippet and inject **/
async function fetchAndInjectHTML(url, targetSelector, handle) {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const elementsToAppend = doc.querySelectorAll(".block_recent-item-info");
    if (!elementsToAppend.length) return;

    const targetElement = document.querySelector(targetSelector);
    if (!targetElement) {
      console.error("Target element not found:", targetSelector);
      return;
    }

    // Prevent duplicates using data-handle
    if (targetElement.querySelector(`[data-handle="${handle}"]`)) {
      return;
    }

    // Append only the first item
    const firstBlock = elementsToAppend[0].cloneNode(true);
    firstBlock.setAttribute("data-handle", handle);
    targetElement.appendChild(firstBlock);

    initSwiper();

    updateRecentlyViewedWrapperVisibility();
  } catch (error) {
    console.error("Error injecting recently viewed HTML:", error);
  }
}

/** Add current product to recently viewed in localStorage **/
function addRecentlyViewedProduct(handle) {
  const key = "recentlyViewedProducts";
  const maxItems = 8;
  let viewed = JSON.parse(localStorage.getItem(key)) || [];

  viewed = viewed.filter((item) => item !== handle);
  viewed.unshift(handle);

  if (viewed.length > maxItems) viewed.pop();
  localStorage.setItem(key, JSON.stringify(viewed));
}

/** Get recently viewed products **/
function getRecentlyViewedProducts() {
  return JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];
}

/** Toggle visibility of recently viewed wrapper **/
function updateRecentlyViewedWrapperVisibility() {
  const wrapper = document.querySelector(".collection.recently-viewd_wrapper");
  const items = document.querySelectorAll(".block_recent-item-info");

  if (!wrapper) return;

  if (items.length > 0) {
    wrapper.classList.remove("hidden");
  } else {
    wrapper.classList.add("hidden");
  }
}

/** Initialize Swiper for recently viewed products **/
function initSwiper() {
  const carousel = document.querySelector(".block__featured-recently-view-wrapper");
  if (!carousel || carousel.classList.contains("swiper-initialized")) return;

  const mobileColumns = parseInt(carousel.getAttribute("data-on-mobile-columns")) || 2;
  const desktopColumns = parseInt(carousel.getAttribute("data-on-desktop-columns")) || 4;

  new Swiper(carousel, {
    spaceBetween: 0,
    loop: false,
    grabCursor: true,
    navigation: {
      nextEl: ".recently-viewd_slider-button--next",
      prevEl: ".recently-viewd_slider-button--prev",
    },
    breakpoints: {
      310: { slidesPerView: mobileColumns, spaceBetween: 6 },
      750: { slidesPerView: mobileColumns, spaceBetween: 6 },
      768: { slidesPerView: 3, spaceBetween: 6 },
      1200: { slidesPerView: desktopColumns, spaceBetween: 0 },
    },
  });

  carousel.classList.add("swiper-initialized");
  document.querySelector(".recently-viewd_wrapper").classList.remove("hidden");
  
}
